module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Difference-99dbe137fd6bb2a745b574e2cca1e040.svg";